var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellMessageWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 13.6H9.6L6.4 16V13.6H4.8C4.58783 13.6 4.38434 13.5157 4.23431 13.3657C4.08429 13.2157 4 13.0122 4 12.8V4.8C4 4.58783 4.08429 4.38434 4.23431 4.23431C4.38434 4.08429 4.58783 4 4.8 4H15.2C15.4122 4 15.6157 4.08429 15.7657 4.23431C15.9157 4.38434 16 4.58783 16 4.8V12.8C16 13.0122 15.9157 13.2157 15.7657 13.3657C15.6157 13.5157 15.4122 13.6 15.2 13.6Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 9,
    r: 1,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 9,
    r: 1,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 9,
    r: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellMessageWhite);
export default __webpack_public_path__ + "static/media/icn_table_cell_Message_white.652d375ececbbfead069b6ba47d66481.svg";
export { ForwardRef as ReactComponent };